module.exports = __webpack_public_path__ + "img/v1.2f628b18.png";